export const state = {
    countOnPage: 20,
    result: [],
    totalCount: null,
};
